<div class="row d-none">
  <div class="col-12">
    <div class="price-table-container">
      <table class="price-table w-100" *ngIf="productList">
        <tbody>
          <tr *ngFor="let productCategory of productList">
            <th>{{ productCategory.name }}</th>
            <td>{{ productCategory.subTotal | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}</td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <th>{{ 'popins.products_list.aside.total' | translate }}</th>
            <td>{{ productTotalPV | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}</td>
          </tr>
          <tr>
            <th>{{ 'popins.products_list.aside.totalTva' | translate }}</th>
            <td>{{ productTotalTVA | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}</td>
          </tr>
          <tr>
            <th class="ecofees">{{ 'popins.products_list.aside.totalEcotax' | translate }}</th>
            <td class="ecofees">{{ productTotalEcotax | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}</td>
          </tr>
        </tfoot>
      </table>
    </div>
    <div class="legacy" [innerHtml]="'popins.products_list.aside.disclaimer' | translate"></div>
  </div>

  <div class="col-12">
    <div class="header-actions">
      <button class="close" (click)="modalService.close()" title="{{ 'generic.close' | translate }}">
        <span class="icon-view-close" aria-hidden="true">
          <svg>
            <use xlink:href="assets/img/icons.svg#icon-view-close"></use>
          </svg>
        </span>
        <span>{{ 'generic.close' | translate }}</span>
      </button>
    </div>

    <div class="modal-content-body">
      <div class="init-text pt-5" *ngIf="!productList">
        {{ 'popins.products_list.empty' | translate }}
      </div>

      <div class="product-list p-4 pr-5" *ngIf="productList">
        <table class="table product-table order">
          <ng-container *ngFor="let productCategory of productList">
            <tr class="title-row">
              <td>
                <img
                  width="64"
                  height="64"
                  [src]="productCategory.thumbnailURLSmall"
                  *ngIf="productCategory.thumbnailURLSmall != undefined" />
              </td>
              <td colspan="5" style="text-align: left">
                <h3>{{ productCategory.name }}</h3>
              </td>
              <td>
                <h3>{{ productCategory.subTotal | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}</h3>
              </td>
            </tr>
            <tr class="product-table-label">
              <th>&nbsp;</th>
              <th>
                <span>{{ 'popins.products_list.main.columns.ref' | translate }}</span>
              </th>
              <th colspan="2">
                <span>{{ 'popins.products_list.main.columns.name' | translate }}</span>
              </th>
              <th>
                <span>{{ 'popins.products_list.main.columns.price' | translate }}</span>
              </th>
              <th>
                <span>{{ 'popins.products_list.main.columns.qty' | translate }}</span>
              </th>
              <th>
                <span>{{ 'popins.products_list.main.columns.total' | translate }}</span>
              </th>
            </tr>
            <tr *ngFor="let productRow of productCategory.products; let last = last" [class.last]="last">
              <td>
                <img
                  width="64"
                  height="64"
                  [src]="productRow.thumbnailURLSmall"
                  *ngIf="productRow.thumbnailURLSmall != undefined" />
              </td>
              <td class="ref">{{ productRow.reference }}</td>
              <td colspan="2">{{ productRow.name }}</td>
              <td>{{ productRow.price.current.value | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}</td>
              <td>{{ productRow.quantity }}</td>
              <td>
                {{ productRow.totalPrice | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
                }}<span
                  class="ecofees"
                  *ngIf="productRow.price.ecotax != undefined && productRow.price.ecotax.value > 0"
                  ><br />{{ 'popins.products_list.aside.totalEcotax' | translate }}
                  {{ productRow.price.ecotax.value | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}</span
                >
              </td>
            </tr>
            <tr class="spacer">
              <td colspan="7">&nbsp;</td>
            </tr>
            <ng-container *ngIf="productCategory.key == 'linears'">
              <tr class="spacer">
                <td
                  colspan="7"
                  class="text-center"
                  [innerHtml]="'popins.products_list.aside.disclaimerLinear' | translate"></td>
              </tr>
              <tr class="spacer">
                <td colspan="7">&nbsp;</td>
              </tr>
            </ng-container>
          </ng-container>
        </table>
      </div>
    </div>

    <div class="footer">
      <div class="row">
        <div class="text-left col-4">
          <!-- <ng-casto-btn class="light-grey" (click)="back()" [label]="'popins.installation.back' | translate"></ng-casto-btn> -->
        </div>
        <div class="text-right col-8">
          <!-- <ng-casto-btn class="blue" [disabled]="!projectIsSaved" *ngIf="vendorEnvironment" (click)="downloadLegacyCommerceCsv()" label="Télécharger csv"></ng-casto-btn> -->
          <!-- <ng-casto-btn class="blue" [disabled]="!projectIsSaved" *ngIf="vendorEnvironment" (click)="order()" label="Commander"></ng-casto-btn> -->
          <ng-casto-btn
            class="blue"
            [disabled]="!productList"
            [loading]="printLoading"
            (click)="printList()"
            label="Imprimer"></ng-casto-btn>
        </div>
      </div>
    </div>
  </div>
</div>
